export const taxFilingStatusDropdown = () => [
  { id: 1, description: 'Single' },
  { id: 2, description: 'Head of Household' }, 
  { id: 3, description: 'Qualifying Widow(er)' }, 
  { id: 4, description: 'Married Filing Jointly' },
  { id: 5, description: 'Married Filing Separately' }, 
];
